import { createSignal, createEffect, For, Component } from "solid-js";
import "./index.css";

type Props = {
    count: number;
    isLoading?: boolean;
    height: string;
    width: string;
    gap?: number;
}

export const LoadingSkeleton : Component<Props> = (props) => {
  const [count, setCount] = createSignal(props.count || 3);
  const [isLoading, setIsLoading] = createSignal(props.isLoading !== undefined ? props.isLoading : true);
  
  // Update count if props change
  createEffect(() => {
    if (props.count !== undefined) {
      setCount(props.count);
    }
  });
  
  // Update loading state if props change
  createEffect(() => {
    if (props.isLoading !== undefined) {
      setIsLoading(props.isLoading);
    }
  });

  return (
    <div class="skeleton-container">
      <For each={Array(count()).fill(0)}>
        {(_, i) => (
          <div 
            class={`skeleton-item ${isLoading() ? 'pulse' : ''}`}
            style={{
              "height": `${props.height}`,
              "width": `${props.width}`,
              "margin": `${props.gap || 10}px`
            }}
          />
        )}
      </For>
    </div>
  );
};
